<app-icon *ngIf="icon" [icon]="icon"></app-icon><ng-content></ng-content>
<span *ngIf="loading" class="icon-loader"></span>
